import { createBrowserHistory } from '@remix-run/router';

export default createBrowserHistory({ v5Compat: true });
